import React, { FunctionComponent, useEffect, useState } from 'react'
import { useFeathersClient } from '@strac/react-client-feathers'
import { useQuery } from '@tanstack/react-query'
import { Typography } from 'antd'
import DateRangePicker from './DateRangePicker/DateRangePicker'
import dayjs, { Dayjs } from 'dayjs'
import TripHistoryList, { Trip } from './TripHistoryList/TripHistoryList'

interface IProps {
  vehicleId: number
}

const VehicleLocationHistoryList: FunctionComponent<any> = (props: IProps) => {
  const { vehicleId } = props
  const client = useFeathersClient()

  const [dateRange, setDateRange] = React.useState<
    [start: Dayjs | null | undefined, end: Dayjs | null | undefined]
  >([dayjs().subtract(10, 'day'), dayjs()])

  const { data: vehicle } = useQuery({
    queryKey: ['vehicle', 'get', vehicleId],
    queryFn: async () => client.service('vehicle').get(vehicleId),
    enabled: !!vehicleId
  })

  const { data: trips, isLoading: tripsLoading } = useQuery({
    queryKey: ['trip-history', 'find', vehicle?.asset_id],
    queryFn: async () =>
      client.service('trip-history').find({
        query: {
          sim_ids: [vehicle?.asset_id],
          start_date: dateRange[0]?.format('YYYY-MM-DD').concat(' 00:00:00'),
          end_date: dateRange[1]?.format('YYYY-MM-DD').concat(' 00:00:00')
        }
      }),
    enabled: !!vehicle?.asset_id
  })

  useEffect(() => {
    if (tripsLoading) return
    console.log('trips', trips)
  }, [trips, tripsLoading])

  return (
    <div style={{ height: '100%', overflow: 'auto' }}>
      <div
        style={{
          width: '100%',
          padding: '10px',
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between'
        }}
      >
        <Typography.Title ellipsis={true} style={{ padding: 0, margin: 0 }} level={2}>
          {vehicle?.name}
        </Typography.Title>
      </div>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '5px' }}>
        <DateRangePicker dateRange={dateRange} setDateRange={setDateRange} />
      </div>
      <div style={{ width: '100%', display: 'flex', justifyContent: 'center', padding: '5px' }}>
        <TripHistoryList trips={trips} tripsLoading={tripsLoading} />
      </div>
    </div>
  )
}

export default VehicleLocationHistoryList
